export let prefetch = (id: string) => {
  let link = document.createElement('link');
  link.rel = 'prefetch';
  link.href = `https://widget.onhighloop.com/feedback/${id}`;
  document.head.appendChild(link);
};
